import { FileStore } from "../../entity/file"

const actions = {

  async upload({ commit },file, parent_dir = null) {
    const url = process.env.VUE_APP_API_URL + "files/upload";
    let data = new FormData();
    if (parent_dir) {
      data.append("parent_dir", parent_dir);
    }

    data.append("file", file, file.name);

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const res = await axios.post(url, data, config)
    return res.data.file_store;
  },
  async download({ commit },filepath) {
    const url = process.env.VUE_APP_API_URL + "files/download/"+filepath+"";
    const res = await axios.get(url)
    return res;
  }

  
}

function initialState() {
  return {

  }
}
const state = initialState()

const getters = {}

const mutations = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
